import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

/**
 * UI store — manages global interface state.
 * Sidebar, theme, modals, toast notifications.
 *
 * Not persisted — resets on each page load.
 */
const useUiStore = create(
  devtools(
    (set, get) => ({
      // ── Sidebar ────────────────────────────────────
      // Mobile drawer closed by default — avoids a blocking overlay on small screens.
      sidebarOpen:      false,
      sidebarCollapsed: false,
      toggleSidebar:    ()      => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
      setSidebarOpen:   (value) => set({ sidebarOpen: value }),
      toggleCollapsed:  ()      => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

      // ── Theme ──────────────────────────────────────
      theme:     'light',                    // 'light' | 'dark'
      setTheme:  (theme) => {
        set({ theme })
        document.documentElement.setAttribute('data-theme', theme)
      },
      toggleTheme: () => {
        const next = get().theme === 'light' ? 'dark' : 'light'
        get().setTheme(next)
      },

      // ── Global Loading ─────────────────────────────
      isGlobalLoading: false,
      setGlobalLoading:(value) => set({ isGlobalLoading: value }),

      // ── Active Modal ───────────────────────────────
      activeModal:    null,
      modalPayload:   null,
      openModal:      (id, payload = null) => set({ activeModal: id, modalPayload: payload }),
      closeModal:     ()                   => set({ activeModal: null, modalPayload: null }),
      isModalOpen:    (id)                 => get().activeModal === id,
    }),
    { name: 'UiStore' }
  )
)

export default useUiStore
